import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { FaUserShield } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

// Componenti
import AdminEventi from './AdminEventi.jsx';
import EventoDetail from './EventoDetail.jsx';
import Scontistiche from './Scontistiche.jsx';
import Iscrizione from './Iscrizione.jsx';
import Storia from './Storia.jsx';
import Eventi from './Eventi.jsx';
import AdminPanel from './AdminPanel.js';
import Welcomematricole from './Welcomematricole.jsx';
import Winterweek from './Winterweek.jsx';
import Torneo from './Torneo.jsx';
import BackButton from './BackButton.jsx'; // <-- import del BackButton esterno
import ChatBot from './ChatBot.jsx';

// CSS e immagini
import './Welcome.css';
import './Main.css';
import logo from './assets/logo_associazione.png';
import storiaImg from './assets/storia.png';
import eventiImg from './assets/eventi.png';
import scontisticheImg from './assets/scontistiche.png';

// -------------------- AdminButton --------------------
function AdminButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    const pwd = prompt("Inserisci password admin:");
    if (pwd === "1234") navigate("/admin");
    else alert("Password errata!");
  };

  return (
    <button className="admin-icon" onClick={handleClick} title="Accedi come Admin">
      <FaUserShield size={24} />
    </button>
  );
}

// -------------------- Home --------------------
function Home() {
  const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <Helmet><title>CUSASapp - Home</title></Helmet>
      <AdminButton />
      <div className="welcome-content">
        <img src={logo} alt="Logo Associazione" className="welcome-logo" />
        <h1 className="welcome-title">Benvenuto nella CUSASapp!</h1>
        <p className="welcome-subtitle">Dai un occhio alla nostra comunità ed iscriviti!</p>
        <button className="welcome-button" onClick={() => navigate('/chatbot')}>Chat con il Bot</button>
        <button className="welcome-button" onClick={() => navigate('/main')}>Inizia</button>
        <button className="welcome-button" onClick={() => navigate('/iscrizione')}>Iscriviti all'associazione</button>
      </div>
    </div>
  );
}
function EventoWrapper() {
  const location = useLocation();
  const { evento } = location.state || {};
  if (!evento) return <p>Evento non trovato</p>;

  return <EventoDetail {...evento} />;
}
// -------------------- Main --------------------
function Main() {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <Helmet><title>CUSASapp - Main</title></Helmet>
      <AdminButton />
      <BackButton /> {/* torna sempre a Home */}

      <div className="main-content">
        <img
          src={storiaImg}
          alt="storia"
          className="image"
          onClick={() => navigate('/storia')}
          style={{ cursor: 'pointer' }}
        />
        <img
          src={eventiImg}
          alt="eventi"
          className="image"
          onClick={() => navigate('/eventi')}
          style={{ cursor: 'pointer' }}
        />
        <img
          src={scontisticheImg}
          alt="scontistiche"
          className="image"
          onClick={() => navigate('/scontistiche')}
          style={{ cursor: 'pointer' }}
        />
      </div>
    </div>
  );
}

// -------------------- APP --------------------
function App() {
  return (
    <Router>
      <Routes>
        {/* Pagine principali */}
        <Route path="/" element={<Home />} />
        <Route path="/main" element={<Main />} />
        <Route path="/iscrizione" element={<><BackButton /><Iscrizione /></>} />
        <Route path="/storia" element={<><BackButton /><Storia /></>} />
        <Route path="/eventi" element={<><BackButton /><Eventi /></>} />
        <Route path="/scontistiche" element={<><BackButton /><Scontistiche /></>} />
        <Route path="/chatbot" element={<><BackButton /><ChatBot /></>} />
        <Route path="/chatbot" element={<ChatBot />} />

        {/* Admin */}
        <Route path="/admin" element={<><BackButton /><AdminPanel /></>} />

        {/* Pagine secondarie */}
        <Route path="/admin-eventi" element={<AdminEventi />} />

<Route path="/eventi/:eventId" element={<EventoWrapper />} />
        <Route path="/welcome-matricole" element={<><BackButton /><Welcomematricole /></>} />
        <Route path="/winter-week" element={<><BackButton /><Winterweek /></>} />
        <Route path="/torneo-pallacanestro" element={<><BackButton /><Torneo /></>} />
      </Routes>
    </Router>
  );
}

export default App;
